import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query';
import ax from './ax';
import qs from 'qs';
export function useGet<T>({
    request: { url, params },
    ...queryOptions
}: {
    request: { url: string; params?: object };
} & Partial<UndefinedInitialDataOptions<T, Error>>) {
    return useQuery<T>({
        queryKey: [url, ...Object.values(params ?? []).flatMap(x => x)],
        queryFn: async () => {
            return (
                await ax.get<T>(url, {
                    params,
                    paramsSerializer: {
                        serialize: p => {
                            return qs.stringify(p, { arrayFormat: 'repeat' });
                        },
                    },
                })
            ).data;
        },
        ...queryOptions,
    });
}
